import { Component, Input } from '@angular/core';

import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'tooltip-viewer',
  template: `
    <div
      [style.border-color]="'#' + cService.userProfile.HqColour"
      class="page-tooltip"
      [style.margin-top]="topOffset"
      [style.margin-left]="cService.selectedLanguage?.isRtl ? '0' : leftOffset"
      [style.margin-right]="cService.selectedLanguage?.isRtl ? leftOffset : '0'"
      [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'"
    >
      <div *ngIf="title" [innerHTML]="title | trustAsSafeHtml"></div>
      <hr *ngIf="title" />

      <div *ngIf="description" [innerHTML]="description | trustAsSafeHtml"></div>
    </div>
  `,
  styles: [
    `
      .page-tooltip {
        color: black;
        font-size: 14px;
        background-color: white;
        border: 1px solid;
        border-radius: 10px;
        margin-left: 10px;
        margin-top: 15px;
        padding: 10px;
      }
      .page-tooltip[dir='rtl'] {
        margin-left: 0;
      }
    `,
  ],
})
export class TooltipViewerComponent {
  @Input() title?: string;
  @Input() description: string;
  @Input() topOffset?: string;
  @Input() leftOffset?: string;

  constructor(public cService: CommonService) {}
}
